import { render, staticRenderFns } from "./table-expand-detail.vue?vue&type=template&id=890d4020&"
import script from "./table-expand-detail.vue?vue&type=script&lang=js&"
export * from "./table-expand-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports